module.exports = __webpack_public_path__ + "img/auth2.34c843d5.png";